import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureItem } from '../../feature-item';

@Injectable({
  providedIn: 'root'
})
export class FeatureGroupTemplateService {

  constructor(private http: HttpClient) { }

  // Add Feature Item
  createProposalTemplate(data: any): Observable<any> {
    return this.http.post<any>(`/grouptemplate/create`, data);
  }

  deleteGroupTemplate(data: any): Observable<any> {
    return this.http.delete<any>(`/grouptemplate/${data.groupTemplateId}`, data);
  }

  getProposalTemplates(): Observable<any> {
    return this.http.get<any>(`/grouptemplate`);
  }

  getProposalTemplateById(data: any): Observable<any> {
    return this.http.get<any>(`/grouptemplate/${data}`);
  }

  // Update Feature Item
  updateTemplateProposal(proposalTemplate: any): Observable<any> {
    return this.http.put<any>(`/grouptemplate/updatefeatureintemplate`, proposalTemplate);
  }

  updateProposalTemplateName(data: any): Observable<any> {
    return this.http.put<any>(`/grouptemplate/update`, data);
  }

  addFeatureinGroupTemplate(data: any): Observable<any> {
    return this.http.post<any>(`/grouptemplate/addfeatureintemplate`, data);
  }

  addFeatureItemInGroupTemplate(data: any): Observable<any> {
    return this.http.post<any>(`/grouptemplate/addfeatureitemintemplate`, data);
  }

  updateFeatureItemInGroupTemplate(data: any): Observable<any> {
    return this.http.put<any>(`/grouptemplate/updatefeatureitemintemplate`, data);
  }

  useGroupTemplate(data: any): Observable<any> {
    return this.http.put<any>(`/grouptemplate/usegrouptemplate`, data);
  }

  // Delete Feature Item
  deleteFeature(featureItemId: string): Observable<any> {
    return this.http.delete<any>(`/grouptemplate/removefeatureintemplate/${featureItemId}`);
  }

  deleteFeatureItem(featureItemId: string): Observable<any> {
    return this.http.delete<any>(`/grouptemplate/removefeatureitemintemplate/${featureItemId}`);
  }

  // Update Feature Item Property
  updateFeatureItemProperty(featureItemId: string, property: string, value: any): Observable<any> {
    return this.http.put<any>(`/featureItems/${featureItemId}/${property}`, { value: value });
  }


  // Bulk Update Feature Property
  bulkUpdateFeatureProperty(id: string, property: string, value: any): Observable<any> {
  return this.http.put<any>(`/grouptemplate/${id}/${property}`, { value: value });
  }

  // Bulk Update Feature Item Property
  bulkUpdateFeatureItemProperty(id: string, property: string, value: any): Observable<any> {
    return this.http.put<any>(`/grouptemplate/featureItem/${id}/${property}`, { value: value });
  }

  // Update Feature Item Project Prep Status
  updateFeatureItemProjectPrepStatus(featureItemId: string, projectPrepStatus: string): Observable<any> {
    return this.http.put<any>(`/featureItems/${featureItemId}/projectPrepStatus`, { projectPrepStatus: projectPrepStatus });
  }

  // Update Feature Item Installed Quantity
  updateFeatureItemInstalledQuantity(featureItemId: string, installedQuantity: number): Observable<any> {
    return this.http.put<any>(`/featureItems/${featureItemId}/installedQuantity`, { installedQuantity: installedQuantity.toString() });
  }

  // Get Feature Items
  getFeatureItems(params: any): Observable<{ featureItems: FeatureItem[], count: number }> {
    return this.http.get<{ featureItems: FeatureItem[], count: number }>(`/featureItems`, {
      params: params
    });
  }

  // Pull Feature Item From Inventory
  pullFeatureItemFromInventory(featureItemId: string): Observable<any> {
    return this.http.get<any>(`/featureItems/${featureItemId}/pull`);
  }

  // Return Feature Item To Inventory
  returnFeatureItemToInventory(featureItemId: string): Observable<any> {
    return this.http.get<any>(`/featureItems/${featureItemId}/return`);
  }

  // Sync/Update Template Prices From Inventory Prices
  syncPricesFromInventory(groupTemplateId: string, featureItemIds: string[]): Observable<any> {
    return this.http.put<any>(`/grouptemplate/${groupTemplateId}/inventory/updatePrices`, { featureItemTemplateIds: featureItemIds });
  }

  // Unmatch Item Prices
  getListOfItemWithUnmatchedPrices(groupTemplateId: string): Observable<any> {
    return this.http.get<any>(`/grouptemplate/${groupTemplateId}/unmatchedPrices`);
  }

  updateFeatureOrder(data: any): Observable<any> {
    return this.http.put<any>(`/grouptemplate/updatefeatureorder`, data);
  }

  getDistinctColumnValues(params: any): Observable<string[]> {
    return this.http.get<string[]>(`/features/distinctColumnValues`, {
      params: params
    });
  }
}
